<template>
    <div class="app" v-if="isshow">
        <img class="app-img"  src="../../assets/img/bg0.jpg">
        <!-- 答题部分 -->
        <block is="div">
        <!-- <div> -->
            <!-- <img class="app_imgtou"  src="../../assets/img/dati.png"> -->
            <div class="xin_k">

                <!-- <block is="div" v-if="answerIdx<dataArr.length"> -->
                <div v-if="answerIdx<dataArr.length">
                    <h4><span>第<em>{{bianhao[answerIdx]}}</em>题</span></h4>
                    <p>{{answerIdx+1}}、{{dataArr[answerIdx].question.question}}</p>
                    <!-- <h2><span>{{answerIdx+1}}</span><i>{{dataArr[answerIdx].question.question}}</i></h2> -->
                    <!-- 单选 -->
                    <radio-group is='div' class="app-con" @change="radioChange" v-if="dataArr[answerIdx].question.cat_id == 1">
                    <label class="app-label" v-for="(item,idx) in dataArr[answerIdx].answer" :key="idx"
                        :class="{labelShow:item.checked}"
                    >
                        <img v-if="!item.checked" src="../../assets/img/answer0.png">
                        <img v-if="item.checked" src="../../assets/img/answer1.png">
                        <input type="radio" :value="item.answer" :checked="item.checked"> 
                        <span>{{item.answer}}</span>
                    </label>
                    </radio-group>
                    <!-- 多选 -->
                    <checkbox-group is='div' class="app-con" @change="checkboxChange" v-if="dataArr[answerIdx].question.cat_id == 2"
                    :class="{appCheckbox:answerIdx==2}"
                    >
                        <label class="app-label" v-for="(item,idx) in dataArr[answerIdx].answer" :key="idx"
                        :class="{labelShow:item.checked}"
                        >
                            <img v-if="!item.checked" src="../../assets/img/answer0.png">
                            <img v-if="item.checked" src="../../assets/img/answer1.png">
                        <input type="checkbox" :value="item.answer" :checked="item.checked"> 
                        <span>{{item.answer}}</span>
                        </label>
                        <!-- 多选3其他提示 -->
                        <textarea class="textarea3" v-if="dataArr[answerIdx].istextarea" placeholder="请输入其他内容" v-model="dataArr[answerIdx].textareaText"></textarea>
                        <!-- 多选8其他提示 -->
                        <!-- <textarea class="textarea8" v-if="textarea8 && answerIdx == 7" placeholder="请输入其他内容" v-model="textarea8Text"></textarea> -->
                    </checkbox-group>
                </div>
                <!-- </block>  -->
                <!-- 填写留言部分 -->
                <!-- <block is="div" v-if="dataArr.length>0 && answerIdx>(dataArr.length-1)"> -->
                <div v-if="dataArr.length>0 && answerIdx>(dataArr.length-1)">
                    <caiMessage ref="caiMessage"></caiMessage>
                </div>
                <!-- </block> -->
                <!-- 按钮部分 -->
                <div class="app-btn" v-if="dataArr.length>0">
                    <!-- <div class="app-left" v-if="answerIdx != 0" @touchstart="startFu" @touchmove="moveFu" @touchend="leftBtn">
                        <img src="../../assets/img/answer4.png">
                    </div> -->
                    <div class="app-right" @touchstart="startFu" @touchmove="moveFu" @touchend="rightBtn">
                        <!-- {{dataArr[answerIdx].select}} -->
                        <span v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other != 1 && dataArr[answerIdx].select ==''">下一题</span>
                        <span v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other != 1 && dataArr[answerIdx].select != ''">下一题</span>
                        <span v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other == 1 && dataArr[answerIdx].select.length<1">下一题</span>
                        <span v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other == 1 && dataArr[answerIdx].select.length>0">下一题</span>
                        <span v-if="answerIdx>=(dataArr.length)">提交</span>
                        <!-- <img v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other != 1 && dataArr[answerIdx].select ==''" src="../../assets/img/answer2.png">
                        <img v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other != 1 && dataArr[answerIdx].select != ''" src="../../assets/img/answer3.png">

                        <img v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other == 1 && dataArr[answerIdx].select.length<1" src="../../assets/img/answer2.png">
                        <img v-if="answerIdx<(dataArr.length) && dataArr[answerIdx] && dataArr[answerIdx].question.other == 1 && dataArr[answerIdx].select.length>0" src="../../assets/img/answer3.png">    
                        <img v-if="answerIdx>=(dataArr.length)" src="../../assets/img/answer7.png">     -->
                    </div>
                </div>
            </div>
        <!-- <div> -->
        </block>
        
        <div class="app-div"></div>
         <!-- 登陆组件 -->
        <!-- <caiRegister ref="caiRegister"></caiRegister> -->
        <!-- 提示组件 -->
        <caiToast ref="caiToast"></caiToast>
        <!--弹出抽奖页面-->
        <palylottery v-if="choujiang" @share="share"></palylottery>
    </div>
</template>
<script>
// import {answerData} from '../../utils/answer';//加载数据进来
import CryptoJS from 'crypto-js';
import caiToast from '#/toast';//引入提示插件
import wx from 'weixin-js-sdk';
// import caiRegister from '@/components/register';//引入登陆组件
import caiMessage from '@/components/message';//引入路由模块
import palylottery from '@/components/lottery';//引入路由模块
export default {
  data () {
    return {
        start:0,
        dataArr:[],
        answerIdx:0,
        windowHeight:0,
        // textarea3:false,
        // textarea8:false,
        // textarea3Text:"",
        // textarea8Text:"",
        isajax:false,//是否正在提交
        isshow:false,//是否显示
        bianhao:['一','二','三','四','五','六','七','八','九','十','十一','十二','十三','十四','十五','十六','十七','十八'],
        choujiang:false,//抽奖页面
    }
  },
  components: {
    caiToast,caiMessage,palylottery
    // caiRegister
  },
//   beforeCreate(){
//       this.windowHeight = this.getwindowHeight();
//   },
  created(){
    //   this.windowHeight = this.getwindowHeight();//获取宽高
    this.shareFn();
  },
  beforeMount(){
       this.isshow = false;
       this.answerIdx = 0;
       this.isajax = false;
       this.windowHeight = this.getwindowHeight();//获取宽高
       this.init();
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        this.starttime = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second
      //发请求
        // wx.showLoading({
        //   title: '正在初始化',
        //   mask:true,
        // })
    //   this.dataArr.forEach((e)=>{//更新重组数据
    //       e.isArray = false;
    //       if(Array.isArray(e.answer)){
    //           e.isArray = true;
    //           e.answer = e.answer.map((es)=>{
    //               return{
    //                   name:es,
    //                   checked:false,
    //               }
    //           })
    //       }
    //   })
     // console.log(this.dataArr)
  },
  methods: {
      // 分享
        shareFn(){
            var _this = this;
            let url = window.location.href;
            // console.log(url,777)
            let asanFn = async()=>{
                let jssdkArr = await this.$http.get(`${this.service}wechat/share`,{
                    url:url,
                })
                console.log(jssdkArr,"jddskk")
                if(jssdkArr.status==200){
                    let res = jssdkArr.data;
                    const shareTitle = `东莞医保服务满意度调查活动`;
                    const shareURL = `http://wechat.dgybwj.kuaichuangkeji.com`;
                    const shareDesc = `快来参与“东莞医保服务满意度调查活动”，领取微信红包!`;
                    // const shareURL = res.url;
                    wx.config({
                        debug: false,
                        appId: res.appId,
                        timestamp: res.timestamp,
                        nonceStr: res.nonceStr,
                        signature: res.signature,
                        jsApiList: [
                            'checkJsApi',
                            'onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'hideMenuItems',
                            'showMenuItems',
                            'hideAllNonBaseMenuItem',
                            'showAllNonBaseMenuItem'
                        ]
                    })
                    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                    // 分享朋友
                        wx.onMenuShareAppMessage({ 
                            title: shareTitle, // 分享标题
                            desc: shareDesc, // 分享描述
                            link: shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: _this.$img + _this.detailsInfo.banner, // 分享图标
                            success: function() {
                                alert("分享成功")
                            },
                            cancel: function() {
                                alert("您取消了分享!")
                            }
                        }); 
                    //分享朋友圈
                        wx.onMenuShareTimeline({ 
                            title: shareTitle, // 分享标题
                            desc: shareDesc, // 分享描述
                            link: shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: _this.$img + _this.detailsInfo.banner, // 分享图标
                            success: function() {
                                alert("分享成功")
                            },
                            cancel: function() {
                                alert("您取消了分享")
                            }
                        }); 
                    });
                }
            }
            asanFn();
        },
    // 加密
    encrypt(data) {
        const key = CryptoJS.enc.Latin1.parse('e7b1b3e5a49ae88a');
        // console.log("key:",key);
        const iv = CryptoJS.enc.Latin1.parse('e69d8ee68b9ce5a4');
    // console.log('iv',iv)
    const Base64 = require('js-base64').Base64
        data = Base64.encode(data)
        // console.log('data',data);
        data = CryptoJS.AES.encrypt(data, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            adding: CryptoJS.pad.ZeroPadding
        }).toString()
        // console.log('data11111111', data)
        return Base64.encode(data)
    },
        
    share(){
        this.choujiang = !this.choujiang;
    },
     init(){
        this.$http.post(`${this.service}questionnaire/question?access-token=${this.$store.state.access_token}`).then((data)=>{
            // console.log(data)
            data.forEach((e)=>{//更新重组数据
               e.question.isArray = false;
               e.select = "";
               if(e.question.cat_id == 2){//是否是多选
                    e.question.isArray = true;
                    e.select = [];
                    e.textareaText = "";
                    e.istextarea = false;
                }
                if(e.question.other == 1){
                    e.answer.push({
                        id:0,
                        ques_id:e.question.id,
                        answer:"其他",
                    })
                }
                e.answer.forEach((es)=>{
                    es.checked = false;
                })
            })
            this.dataArr = data;
            this.isshow = true;
            //  wx.hideLoading();
        })
     },
     startFu(){this.start = 0;},
     moveFu(){this.start = 1;},
     radioChange(e){//单选
        this.dataArr[this.answerIdx].select = e.target.value;
        this.dataArr[this.answerIdx].answer.forEach((es)=>{
            if(this.dataArr[this.answerIdx].select == es.answer){
                es.checked = true;
            }else{
                es.checked = false;
            }
        })
     },
     checkboxChange(e){//多选
        if(!Array.isArray(e.target.value)){//h5
            let idx = this.dataArr[this.answerIdx].select.indexOf(e.target.value);
            if(idx>-1){
                this.dataArr[this.answerIdx].select.splice(idx,1);
            }else{
                this.dataArr[this.answerIdx].select.push(e.target.value);
            }
        }else{//小程序
            this.dataArr[this.answerIdx].select = e.target.value;
        }
       this.ischecked();
    },
    ischecked(){
      this.dataArr[this.answerIdx].answer.forEach((es)=>{
          es.checked = false;
      })
      this.dataArr[this.answerIdx].select.forEach((e)=>{
          this.dataArr[this.answerIdx].answer.forEach((es)=>{
              if(e == es.answer){
                  es.checked = true;
              }
          })
      })
    },
     rightBtn(){//右边按钮点击
         if(this.answerIdx<(this.dataArr.length-1) && this.dataArr[this.answerIdx].select.length<1){
            this.$refs.caiToast.showFu({
                 msg:'请先选择一个答案',
                 time:1500
            })
            return;
         }
         if(this.answerIdx>(this.dataArr.length-1)){
             this.rightBtnEnd();
             return;
         }
        //   if(this.answerIdx == (this.dataArr.length-1)){//如果是提交
        //       this.answerRecord()
        //       return;
        //   } 
         setTimeout(()=>{
            this.answerIdx++;
         },100)
     },
     rightBtnEnd(){//答题结束
        if(this.isajax){return;}
        // if(this.$refs.caiMessage.msg == ""){
        //     this.$refs.caiToast.showFu({
        //         msg:'建议不能为空',
        //         time:1500
        //     })
        //     return;
        // }
        // if(this.$refs.caiMessage.phone == ""){
        //     this.$refs.caiToast.showFu({
        //         msg:'联系方式不能为空',
        //         time:1500
        //     })
        //     return;
        // }
        // if(!/^1[3|4|5|7|8][0-9]{9}$/.test(this.$refs.caiMessage.phone)){
        //     this.$refs.caiToast.showFu({
        //         msg:'联系方式手机号码填写错误',
        //         time:1500
        //     })
        //     return;
        // }
        if(this.$refs.caiMessage.msg==''){
            this.$refs.caiToast.showFu({
                 msg:'意见不能为空',
                 time:1500
            })
            return
        }
        this.isajax = true;
        this.$http.post(`${this.service}questionnaire/leave-msg?access-token=${this.$store.state.access_token}`,{
          //  leave_moblie:this.$refs.caiMessage.phone,//手机号
            leave_words:this.$refs.caiMessage.msg,//留言信息 返回样例：
        }).then((data)=>{
            if(data.status == 1){
                this.answerRecord();//提交问卷
            }else{
                this.$refs.caiToast.showFu({
                    msg:data.info,
                    time:1500
                })
                this.isajax = false;
            }
        })
     },
     leftBtn(){//左边按钮点击
         if(this.answerIdx<=0){return;}
         setTimeout(()=>{
            this.answerIdx--;
         },100)
     },
     answerRecord(){//问卷记录提交
        //  数据收集
         let upData = [];
         this.dataArr.forEach((e)=>{
             e.answer.forEach((es)=>{
                 if(es.checked){
                     if(es.answer == '其他'){
                         es.answer = e.textareaText;
                     }
                     upData.push({
                         ques_id:es.ques_id,
                         answer:es.answer,
                         answer_id:es.id
                     })
                 } 
             })
         })
         var tokenc = window.localStorage.getItem('access_token');
         let fort = {
             starttime:this.starttime,
             token:tokenc,
             data:upData,
         }
         let data = this.encrypt(JSON.stringify(fort))

         this.$http.post(`${this.service}questionnaire/answer-record?access-token=${this.$store.state.access_token}`,{
             data
             }).then((dataa)=>{
           //  console.log(data);
             this.isajax = false; 
             if(dataa.status == 1){
                let d = this.$store.state.status;
                d.isanswer = 1;
                this.$store.commit('setStatus',d); 
                setTimeout(()=>{
                    // this.setStorageSync('is_award',data.is_award);
                    // this.$store.commit('setIsAward',data.is_award);
                    // this.$router.replace('/pages/index/main');
                    // window.localStorage.setItem('prize_id',data.prize_id);
                    // this.$router.replace(`/pages/luckDraw/main?prize_id=${data.prize_id}`);
                    // this.$router.push({ name: "luckDraw" })
                    this.choujiang = !this.choujiang;
                    console.log(dataa,'答完题')
                },1500) 
            }
            let info = '提交成功';
            info = dataa.info?dataa.info:info;
            this.$refs.caiToast.showFu({
                msg:info,
                time:1500
            })
             
         })
     },
  },
  watch:{
      dataArr:{
          handler(newValue, oldValue) {
　　　　　     newValue.forEach((e,idx)=>{
                   if(e.question.other == 1){
                        e.istextarea = e.select.includes('其他');
                   }
              })  
    　　　 },
    　　　 deep: true
      }
  },
  onUnload(){
     // console.log('我触发了');
     this.isshow = false;
  },
  onShareAppMessage(){//自定义转发
      return {
        title: '平安有我 民意收集',
        path: '/pages/index/main',
        imageUrl:'../../assets/img/answer0.png'
      }
    }
}
</script>

<style scoped lang="less">
@import '../../assets/css/less.less';
.app{position: relative; z-index: 0; width: 100%; 
  min-height: 100%;
//   height: 100%;
  box-sizing: border-box;
//   padding: 52/@r 50/@r 0;
//   background: url(http://apipawjtest.kuaichuangkeji.com/bg1.efcbd93.jpg) no-repeat center center;
// //   background: url(../../assets/img/bg1.jpg) no-repeat center center;
//   background-size: 100% 100%;
}
.app-div{height: 140/@r;}
.app-img{position: absolute; left: 0; top: 0; z-index: -1; width: 100%; height: 100%;}
.app_imgtou {position: relative;width: 3.72rem; height: 1.37rem;display: block;margin: auto;}
.xin_k {width:calc(100% - 1rem);position: absolute;border-radius: 10/@r;background-color: #fff;border:.10rem solid #eeab62;margin:0;padding: 0 .30rem;box-sizing: border-box;border: 6/@r solid #5edacd;height: calc(100% - .86rem);top: 52/@r;left: 50%;transform: translateX(-50%);}
.xin_k h4 {width: 100%;position: relative;text-align: center;}
.xin_k h4 span {font-size: .38rem;line-height: .54rem;display: inline-block;border-radius: 2rem;padding: 0 .30rem;color: #31966d;font-family: heavy;font-weight: bold;}
.xin_k h4 span em {padding: 0 .10rem;font-style: normal;font-weight: bold;}
.xin_k p {font-size: .28rem;line-height: .36rem;width: 100%;position: relative;color: #666;margin: .50rem 0 0;}
.app h2{ width: 100%; color: #2366af; font-size: 36/@r; font-weight: bold;
  .box;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  line-height: 1.6;
}
.app h2 span{ min-width: 50/@r; min-height: 50/@r; border-radius: 50%; background: #2366af; color: #fff; font-size: 26/@r; .box;
  margin:2/@r 15/@r 0 0; font-weight: 400;
}
.app h2 i{font-weight: bold;}
//内容区
.app-con{width: 100%; background: #fff; /*border: 2/@r solid #265c8b;*/ border-radius: 10/@r;
  margin-top: 50/@r;/* padding: 50/@r 40/@r; */box-sizing: border-box; font-size: 30/@r; color: #333;
  .box; .box-frap;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.app-label{width: 100%; .box; position: relative;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
//   margin-bottom: 34/@r;
padding: 17/@r 0;
}
.app-label span{ flex: 1;}
//多选样式
// .appCheckbox .app-label span{ flex: 1;}
.appCheckbox .app-label:nth-child(2n){  width: 40%;}
.appCheckbox .app-label:nth-child(2n-1){  width: 60%;}
.appCheckbox .app-label:nth-last-of-type(2){ width: 100%;}
.appCheckbox .app-label:nth-last-of-type(1){ width: 100%;}
//结束
.app .labelShow{color: #31966d;}
.app-label input{position: absolute; left: 0; top: 0; z-index: 9; width: 100%; height: 100%; opacity: 0;}
.app-label img{ width: 54/@r; height: 54/@r; margin-right: 20/@r;}
//按钮部分
.app-btn{ width: calc(100% - 1.02rem); height: 94/@r; position: absolute;left: 50%; transform: translateX(-50%); bottom: 45/@r; border-radius: 10/@r;margin: 0;background-color: #31966d;display: flex;}
// .app-btn div{position: absolute; top: 0; width: 1.9rem; height: .58rem; .box;}
// .app-btn div{font-size: 28/@r;color: #fff;}
.app-left{ left: 0;}
.app-right{width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;}
.app-right span{font-size: 28/@r;color: #fff;}
.app-btn div img{ width: 100%; height: 100%;}
//填写信息部分
.textarea3,.textarea8{
    display: block; width: 100%;
    resize:none;outline:none; font-size: 28/@r; color: #333;
     height: 200/@r; border-radius: 10/@r; box-sizing: border-box; padding: 20/@r;
     border: 2/@r solid #999999; line-height: 1.6; background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/answer/index.vue